import { attestationLabel, SHARE_FOOTER_NOTE, type TEntityPlanRow } from '@verifime/components';
import type { TEntityPlan } from './entityPlan';

/**
 * What the confirm screen asks of the person before the primary, and tells them after it (618 L2,
 * L8; #572 Q5, Q5a). Pure. Nothing here is stored: proceeding is the attestation.
 */

/**
 * A step that shares or creates something. Going Home shares and creates nothing, so it carries
 * neither the attestation nor the footer.
 */
const sharesOrCreates = (plan: TEntityPlan) => plan.action.then !== 'nothing-to-start';

/** The entity the plan is for: the row after the Individual's, when there is one. */
const entityRowOf = (plan: TEntityPlan): TEntityPlanRow | undefined => plan.rows[1];

/**
 * What an established person attests to: who they are and, with an entity row, that they control
 * the entity (named by its own name, else by its type). A brand-new person attests to nothing (L8).
 * Nothing too when the label would be empty: the panel must not ask for what it cannot name.
 */
export function attestationLabelFor(plan: TEntityPlan): string | undefined {
  if (!plan.person.isEstablished || !sharesOrCreates(plan)) {
    return undefined;
  }
  const entity = entityRowOf(plan);
  const label = attestationLabel(plan.person.name, entity?.name, entity?.label);
  return label || undefined;
}

/** The footer note for a step that shares or creates, a brand-new person's included (W16). */
export const footerNoteFor = (plan: TEntityPlan): string | undefined =>
  sharesOrCreates(plan) ? SHARE_FOOTER_NOTE : undefined;
